import React, { useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import { builder } from "Classes/global";
import { Robot } from "Classes/Robot";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import { CurrentDrawerOpenType, toggleDrawer } from "state/slices/RightDrawerSlice";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

interface ComponentProps {
    classes: string;
    type: string;
    payload: unknown;
    icon: boolean;
}

const defaultProps = {
    class: "",
    type: "",
    payload: "",
    icon: false,
};

const DrawerRemoveObjectComponent = ({ classes, type, icon }: ComponentProps): JSX.Element => {
    const dispatch = useTypedDispatch();
    const [buttonLabel, setButtonLabel] = useState("Remove object");
    const isDrawerOpen = useTypedSelector((store) => store.ModelWindow.isModelOpen);
    const drawerOpenType = useTypedSelector((store) => store.ModelWindow.type);

    useEffect(() => {
        if (isDrawerOpen) {
            switch (drawerOpenType) {
                case CurrentDrawerOpenType.BSUObject:
                    setButtonLabel("Remove BSU");
                    break;
                case CurrentDrawerOpenType.Console:
                    setButtonLabel("Remove");
                    break;
                case CurrentDrawerOpenType.Port:
                    setButtonLabel("Remove Port");
                    break;
                case CurrentDrawerOpenType.Stack:
                    setButtonLabel("Remove");
                    break;
                case CurrentDrawerOpenType.Trolley:
                    setButtonLabel("Remove");
                    break;
                case CurrentDrawerOpenType.Anesthesia:
                    setButtonLabel("Remove");
                    break;
                case CurrentDrawerOpenType.Surgeon:
                    setButtonLabel("Remove");
                    break;
                case CurrentDrawerOpenType.Slave:
                    setButtonLabel("Remove");
                    break;
                default:
                    setButtonLabel("Remove Object");
            }
        }
    }, [isDrawerOpen]);

    const handleRemoveObject = (): void => {
        const currentSelectedObject = builder.room.selectedObject as Robot;
        switch (type) {
            case CurrentDrawerOpenType.BSUObject:
                dispatch(toggleDrawer(CurrentDrawerOpenType.BSUObject));
                break;

            case CurrentDrawerOpenType.Console:
                dispatch(toggleDrawer(CurrentDrawerOpenType.Console));
                break;

            case CurrentDrawerOpenType.Port:
                dispatch(toggleDrawer(CurrentDrawerOpenType.Port));
                break;

            case CurrentDrawerOpenType.Stack:
                dispatch(toggleDrawer(CurrentDrawerOpenType.Stack));
                break;

            case CurrentDrawerOpenType.Trolley:
                dispatch(toggleDrawer(CurrentDrawerOpenType.Trolley));
                break;
            case CurrentDrawerOpenType.Anesthesia:
                dispatch(toggleDrawer(CurrentDrawerOpenType.Anesthesia));
                break;
            case CurrentDrawerOpenType.Surgeon:
                dispatch(toggleDrawer(CurrentDrawerOpenType.Surgeon));
                break;
            case CurrentDrawerOpenType.Slave:
                dispatch(toggleDrawer(CurrentDrawerOpenType.Slave));
                break;
        }
        builder.room.remove(currentSelectedObject);

        const drawerWindow = document.getElementById("drawerWindow");
        drawerWindow?.classList.remove("open");
    };
    if (icon) {
        return (
            <IconButton size="medium" onClick={handleRemoveObject}>
                <DeleteOutlinedIcon style={{ color: "#E6117B", fontSize: "30px" }} />
            </IconButton>
        );
    } else {
        return (
            <Button
                onClick={handleRemoveObject}
                fullWidth
                size="large"
                variant="contained"
                className={`btn pinkRoundedButton ${classes}`}
            >
                {buttonLabel}
            </Button>
        );
    }
};
DrawerRemoveObjectComponent.defaultProps = defaultProps;

export default DrawerRemoveObjectComponent;
